import { TemplateElement, html, defineElement } from '@webtides/element-js';

/**
 * @property {number} currentPage
 * @property {number} previousPageIndex
 * @property {number} pageSize
 * @property {number} totalItems
 * @property {string} resultText
 * @property {string} toText
 * @property {string} ofText
 */
export default class PageCount extends TemplateElement {
    properties() {
        return {
            currentPage: 0,
            previousPageIndex: -1,
            pageSize: 7,
            totalItems: -1,
            resultText: '',
            toText: 'to',
            ofText: 'of',
        };
    }

    connected() {
        this.previousPageIndex = this.currentPage - 1;
        this.setAttribute('role', 'status');
        this.requestUpdate();
    }

    template() {
        if (!this.totalItems) {
            return `
                ${this.resultText} (0)
            `;
        }

        const from = (this.previousPageIndex + 1) * this.pageSize + 1;
        const to = Math.min(this.currentPage * this.pageSize + this.pageSize, this.totalItems);

        return html`
            ${this.resultText} (${from}<span aria-label="${this.toText}">-</span>${to} ${this.ofText} ${this.totalItems})
        `;
    }
}

defineElement('page-count', PageCount);
